var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSampleHole(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_00000065064890418087900900000000673288663717547180_);}\n\t.st2{fill:url(#SVGID_00000090979282178449678500000011961617206066665360_);}\n\t.st3{fill:url(#SVGID_00000068665444349413474310000008979618554097164684_);}\n\t.st4{fill:url(#SVGID_00000035517743291024779090000013816073629773622445_);}\n\t.st5{fill:url(#SVGID_00000023243703231165445610000016290721225452780171_);}\n\t.st6{fill:url(#SVGID_00000176041644613239075510000011443446992572682152_);}\n\t.st7{fill:url(#SVGID_00000151528093511022488440000011285658733436711590_);}\n\t.st8{fill:url(#SVGID_00000114779035011163649210000009229699983228347779_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.8826,
    y1: 108.7212,
    x2: 471.1875,
    y2: 108.7212
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M303.1,146.4l1.5,0.1c7-0.7,14.2-5.7,13.5-13.1c-0.8-7.3-7.4-13.3-14.5-15.4c-5.1-1.5-11-1.8-14.7-5.6 c-3.4-3.5-3.8-9-2.8-13.7c0.9-4.7,3-9.1,3.5-13.9c0.5-4.8-0.8-10.3-5-12.9c-1.6-1-3.7-1.4-5.3-0.6c-0.9,0.4-4.4,6-4.9,6.8 c-13,21.5-11.1,29-7.1,46.8c0.9,4,2.2,8.1,4.8,11.3c2.4,3,5.7,5.1,9.1,6.8C287.2,146.3,293.6,146.3,303.1,146.4z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181776939583953779360000006753790524708799410_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.8826,
    y1: 92.2366,
    x2: 471.1875,
    y2: 92.2366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000181776939583953779360000006753790524708799410_)"
    },
    d: "M515.4,78.2c-6.2-28-31.4-29.9-48.1-31.2 c-8.6-0.6-17.5-1.3-21.6-4.7c-3.2-2.6-6.3-5.3-9.2-7.8c-13.2-11.4-26.7-23.1-46-23.1c-9.3,0-20,2.7-32.6,9.5l2,3.7l-1.9-3.3 c-15.5,9-29.1,21.6-39.1,36.5c-11.5,17.1-16.3,40.8-1.1,55.4c8.4,8,18.7,9.4,28.6,9.4c2.6,0,5.2-0.1,7.8-0.2 c2.5-0.1,4.8-0.2,7.1-0.2c2.9,0,5.6,0.1,8.1,0.6c10.8,2.1,19.6,11.2,28.9,20.9c8.5,8.8,17.2,18,28.9,23.7 c7.7,3.8,16.2,5.6,24.9,5.6c18,0,36.5-7.8,49-22.1C516.4,133.2,521.7,106.7,515.4,78.2z M488.6,139.2c-8.7,10-22.1,13.6-34.6,15.6 c-17.3,2.7-33.3-10.6-41.2-18.8c-11.2-11.7-23.9-25.8-42.4-29.3c-4.3-0.8-8.5-1-12.7-1c-2.8,0-5.6,0.1-8.3,0.2 c-2.6,0.1-5,0.2-7.2,0.2c-6.9,0-11.6-0.7-14.7-3.7c-6.2-5.9-1.6-23.8,5.1-33.7c8.7-12.8,20.3-23.7,33.8-31.5l-0.3-0.4 c9.3-5,16.6-6.5,23-7.1c14-1.3,37.5,21.5,41.1,24.3c9.8,8,25.7,12.1,38.2,13.1c20,1.5,27.7,3.2,30.4,15.3 C503.8,105.3,500.1,126,488.6,139.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017496971650641197880000001390960036286779320_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.8826,
    y1: 327.779,
    x2: 471.1875,
    y2: 327.779
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017496971650641197880000001390960036286779320_)"
    },
    d: "M437,312.1c-7.8-4.4-9.2-5.2-8.2-12.6 c0.8-5.8,3.8-11.6,7-17.9l2.6-5c12.3-25,16.5-52.1,11.7-76.1c-3.3-16.6-15.9-23.4-28.2-30c-10.9-5.9-23.3-12.5-34.3-27.6 c-7.2-9.9-15.9-15-25.7-15c-13.8,0-26,9.9-36.5,20.1c-19,15.2-26.4,29-27.3,51c-0.7,16.6,5.2,31.5,10.8,45.8l2.6,6.8 c16.5,43.2,21,57.6,15.8,100.5c-3.6,29.8-11.8,40.1-21.3,52c-9.9,12.4-21.2,26.5-26.7,60.8c-2.4,14.8-3.7,33.7,7.6,48 c7.5,9.5,19.5,14.9,32.9,14.9c7.6,0,15.1-1.8,21.8-5.1c18.2-9.2,28.1-26.9,33.3-40.2c2.1-5.4,3.7-8.6,5.1-11.4 c2.3-4.6,4.5-8.9,7.1-18.6c2.6-9.7,5.1-11.3,10.5-14.9c5-3.3,11.7-7.8,18.9-18.2c3.9-5.7,8.1-11.3,12.3-16.8 c7.2-9.6,14.7-19.4,20.9-30.4c2.6-4.5,4.3-5.8,6-7c9.5-6.8,8.2-14.4,5.2-25.4C456.2,322.9,444.6,316.4,437,312.1z M431.1,361.5 c-5.4,9.7-12.2,18.5-19.3,27.9c-4.4,5.8-8.8,11.7-13,17.7c-4.8,7-8.8,9.7-13.1,12.5c-6.8,4.6-14.6,9.8-19.2,27.2 c-2,7.5-3.5,10.4-5.5,14.5c-1.7,3.3-3.6,7-6,13.4c-3.8,9.8-10.8,22.7-22.9,28.8c-3.6,1.8-8,2.8-12.2,2.8c-6.9,0-12.7-2.5-16.1-6.8 c-6.1-7.8-5-20.9-3.3-31.4c4.6-28.7,13.2-39.5,22.3-50.8c10.6-13.2,21.5-26.9,25.8-62.8c5.7-47.6,0.1-65.6-17.1-110.6l-2.7-7 c-5.1-12.9-9.9-25-9.4-37.1c0.7-15.6,5.2-23.9,20.1-35.8c3.8-3.6,15.3-14.7,22.4-14.7c1,0,4,0,8.5,6.2 c13.9,19.1,29.8,27.6,41.5,33.9c11.8,6.3,16.1,9.1,17.3,15.3c3.9,19.5,0.3,41.8-9.9,62.6l-2.4,4.7c-3.7,7.2-7.9,15.3-9.2,24.7 c-3,21.8,10.2,29.2,18.9,34.1c6.6,3.7,11.4,6.4,13.7,14.6c0.5,1.6,0.8,2.9,1,3.8C438.6,351.2,434.9,354.8,431.1,361.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094589156423400763930000016525936479750358175_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.8826,
    y1: 570.9388,
    x2: 471.1875,
    y2: 570.9388
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000094589156423400763930000016525936479750358175_)"
    },
    d: "M347.2,551.9l-30.8,0.2 c-10.4,0.1-18.9,8.7-18.8,19.1c0.1,10.4,8.7,18.9,19.1,18.8l30.8-0.2c10.4-0.1,18.9-8.7,18.8-19.1 C366.3,560.3,357.7,551.8,347.2,551.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000060749307296971410850000014828868700859271071_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.8826,
    y1: 499.216,
    x2: 471.1875,
    y2: 499.216
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000060749307296971410850000014828868700859271071_)"
    },
    d: "M412.8,487.9l-18.2,0.1 c-6.2,0-11.2,5.1-11.1,11.3c0,6.2,5.1,11.2,11.3,11.1l18.2-0.1c6.2,0,11.2-5.1,11.1-11.3C424,492.9,419,487.9,412.8,487.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003784689238321689010000014580670143618787990_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.8072,
    y1: 300.7652,
    x2: 400.517,
    y2: 300.7652
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003784689238321689010000014580670143618787990_)"
    },
    d: "M272,293.4H131.7 c-3-8.2-10.8-14.1-20.1-14.1c-11.8,0-21.4,9.6-21.4,21.4s9.6,21.4,21.4,21.4c9.3,0,17.1-5.9,20.1-14.1H272c4,0,7.3-3.3,7.3-7.3 S276,293.4,272,293.4z M111.6,309.6c-4.9,0-8.9-4-8.9-8.9c0-4.9,4-8.9,8.9-8.9s8.9,4,8.9,8.9C120.5,305.7,116.5,309.6,111.6,309.6z "
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000160177420681560516180000011332326118423361153_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.8072,
    y1: 219.1506,
    x2: 400.517,
    y2: 219.1506
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000160177420681560516180000011332326118423361153_)"
    },
    d: "M149.2,212.3c9.3,0,17.1-5.9,20.1-14.1 H202v63.3c0,4,3.3,7.3,7.3,7.3h28.2c4,0,7.3-3.3,7.3-7.3c0-4-3.3-7.3-7.3-7.3h-20.9l-0.3-63.4c0-4-3.3-7.3-7.3-7.3 c-0.4,0-0.5-0.1-0.8,0h-38.8c-3-8.2-10.8-14.1-20.1-14.1c-11.8,0-21.4,9.6-21.4,21.4S137.4,212.3,149.2,212.3z M149.2,182 c4.9,0,8.9,4,8.9,8.9c0,4.9-4,8.9-8.9,8.9s-8.9-4-8.9-8.9C140.4,186,144.3,182,149.2,182z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145771930636059005140000000585468666375067819_",
    gradientUnits: "userSpaceOnUse",
    x1: 91.8072,
    y1: 382.3798,
    x2: 400.517,
    y2: 382.3798
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145771930636059005140000000585468666375067819_)"
    },
    d: "M237.5,332.7h-28.2c-4,0-7.3,3.3-7.3,7.3 v63.3h-32.7c-3-8.2-10.8-14.1-20.1-14.1c-11.8,0-21.4,9.6-21.4,21.4c0,11.8,9.6,21.4,21.4,21.4c9.3,0,17.1-5.9,20.1-14.1h38.8 c0.4,0.1,0.4,0,0.8,0c4,0,7.3-3.3,7.3-7.3l0.3-63.4h20.9c4,0,7.3-3.3,7.3-7.3C244.7,335.9,241.5,332.7,237.5,332.7z M149.2,419.5 c-4.9,0-8.9-4-8.9-8.9c0-4.9,4-8.9,8.9-8.9s8.9,4,8.9,8.9C158.1,415.5,154.1,419.5,149.2,419.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062167885487820016300000017820981513908384398_",
    gradientUnits: "userSpaceOnUse",
    x1: -53.8826,
    y1: 269.8078,
    x2: 471.1875,
    y2: 269.8078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#092620"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1121,
    style: {
      stopColor: "#1D4D2F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2703,
    style: {
      stopColor: "#367D40"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4278,
    style: {
      stopColor: "#4BA64F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5815,
    style: {
      stopColor: "#5BC55A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7305,
    style: {
      stopColor: "#67DB62"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8724,
    style: {
      stopColor: "#6EE867"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#70ED69"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062167885487820016300000017820981513908384398_)"
    },
    d: "M492.8,251.7c6-30.1-10-30.1-10-30.1 s-17.1-1-19.7,20.1c-2.7,21.1-17.4,51.3-17.4,51.3c-8.7,20.2,24.3,25.1,24.3,25.1s33,2,24.3-15.1 C485.5,285.9,486.8,281.8,492.8,251.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSampleHole);
export default __webpack_public_path__ + "static/media/icon-sample-hole.60ebc441101101a5b39060920af5f128.svg";
export { ForwardRef as ReactComponent };